const Key = {
    API_KEY_PORTAL_SERVICE: '557C48D0-7A02-44F0-BA78-EB37B5213B2D',//API_KEY_SERVICE
    API_KEY_SECURITY_SERVICE: 'B5FF40FF-5527-4053-B9BC-D6B81F70E635',//API_KEY_2
};

export default Key